import React, { Component } from "react";
import "./style.less";
import { Radio, Button, message, Modal, Card, Input } from "antd";
import { postInvoiceInfo } from "../../api/invoice";
import Storage from "@/utils/storage";
import AreaDropdown from "../AreaDropdown";

const RadioGroup = Radio.Group;
const PERSONAL_ELECTRONIC_INVOICE = "E_INVOICE";
const PERSONAL_PAPER_INVOICE = "P_INVOICE";

class Personal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      invoiceWay: PERSONAL_ELECTRONIC_INVOICE,
      invoiceType: 'COMMON',
      addressProvince: "北京",
      addressCity: "北京",
      invoiceTitle: ""
    };
  }

  setProvinceCity = (province, city) => {
    if (province) {
      this.setState({
        addressProvince: province,
        addressCity: city
      });
    } else {
      this.setState({
        addressCity: city
      });
    }
  };

  checkPhone = data => {
    if (/^1[34578]\d{9}$/.test(data)) {
      return true;
    } else {
      message.warning("手机号格式错误");
    }
  };
  handleChange = (type, e) => {
    this.setState({
      [type]: e.target.value
    });
  };
  warning = data => {
    Modal.warning({
      title: "警告：",
      content: data
    });
  };
  postData(data) {
    postInvoiceInfo(data).then(res => {
      if (res.code === 0) {
        message.info("发票申请已提交，请在发票列表查看");
        window.setTimeout(() => {
          window.location.href = "/v5/invoice/invoiceList";
        }, 1000);
      } else {
        this.warning(res.msg);
      }
    });
  }
  subInfo = () => {
    let data = {
      ...this.state,
      invoiceTitle: "个人",
      tax: "增值税普通发票",
      accountBank: "无",
      bankCard: "无",
      enterpriseAddress: "无",
      enterpriseTel: "无",
      content: "无",
      postCode: "无",
      orderList: Storage.invoiceList.get().map(invoice => invoice.orderId),
      invoiceWay: this.state.invoiceWay === PERSONAL_ELECTRONIC_INVOICE ? 'E_INVOICE' : 'P_INVOICE'
    };
    if (
      data.invoiceWay === "E_INVOICE" &&
      this.checkPhone(data.phoneNumber) &&
      data.receiver &&
      data.invoiceTitle &&
      data.email
    ) {
      data.addressCity = "";
      data.addressProvince = "";
      data.addressDetail = "";
      this.postData(data);
    } else if (
      data.invoiceWay === "P_INVOICE" &&
      this.checkPhone(data.phoneNumber) &&
      data.receiver &&
      data.invoiceTitle &&
      data.addressDetail
    ) {
      data.email=""
      this.postData(data);
    } else {
      message.warning("信息不完整，请重新填写");
    }
  };
  onChange = e => {
    this.setState({
      invoiceWay: e.target.value
    });
  };
  render() {
    const { invoiceWay, invoiceTitle } = this.state;
    return (
      <div className='personal'>
        <div className='person'>
          <div className='invoiceInput'>
            <div className='text'>
              <span className='name'>发票类型：</span>
            </div>
            <div className='input'>
              <RadioGroup
                className='radioGroup'
                onChange={this.onChange}
                value={invoiceWay}
              >
                <Radio value={PERSONAL_ELECTRONIC_INVOICE}>
                  增值税普通发票（电子）
                </Radio>
                <Radio value={PERSONAL_PAPER_INVOICE}>
                  增值税普通发票（纸质）
                </Radio>
              </RadioGroup>
            </div>
          </div>
          <div className='invoiceInput'>
            <div className='text'>
              <span style={{ color: "red", marginLeft: 10 }}>*</span>
              <span className='name'>发票抬头:</span>
            </div>
            <Input
              className='input'
              placeholder='请输入发票抬头'
              value={invoiceTitle}
              onChange={e => {
                this.handleChange("invoiceTitle", e);
              }}
            />
          </div>
          <div className='invoiceInput'>
            <div className='text'>
              <span style={{ color: "red", marginLeft: 25 }}>*</span>
              <span className='name'>收件人:</span>
            </div>
            <Input
              className='input'
              placeholder='请输入收件人姓名'
              value={this.state.receiver}
              onChange={e => {
                this.handleChange("receiver", e);
              }}
            />
          </div>
          {invoiceWay === PERSONAL_ELECTRONIC_INVOICE ? (
            <div className='invoiceInput'>
              <div className='text'>
                <span style={{ color: "red", marginLeft: -2 }}>*</span>
                <span className='name'>收件人邮箱:</span>
              </div>
              <Input
                className='input'
                placeholder='建议QQ邮箱'
                value={this.state.email}
                onChange={e => {
                  this.handleChange("email", e);
                }}
              />
            </div>
          ) : null}
          <div className='invoiceInput'>
            <div className='text'>
              <span style={{ color: "red", marginLeft: 24 }}>*</span>
              <span className='name'>手机号:</span>
            </div>
            <Input
              className='input'
              placeholder='请输入手机号'
              value={this.state.phoneNumber}
              onBlur={this.checkPhone.bind(this, this.state.phoneNumber)}
              onChange={e => {
                this.handleChange("phoneNumber", e);
              }}
            />
          </div>
          {invoiceWay === PERSONAL_ELECTRONIC_INVOICE ? null : (
            <div>
              <div className='invoiceInput'>
                <div className='text'>
                  <span style={{ color: "red", marginLeft: 11 }}>*</span>
                  <span className='name'>省市地址:</span>
                </div>
                <div className='input'>
                  <AreaDropdown setProvinceCity={this.setProvinceCity} />
                </div>
              </div>
              <div className='invoiceInput'>
                <div className='text'>
                  <span style={{ color: "red", marginLeft: 11 }}>*</span>
                  <span className='name'>详细地址:</span>
                </div>
                <Input
                  className='input'
                  placeholder='请输入详细地址'
                  value={this.state.addressDetail}
                  onChange={e => {
                    this.handleChange("addressDetail", e);
                  }}
                />
              </div>
            </div>
          )}

          <Card className='promptCard' type='inner' title='提示' size='small'>
            <div>
              增值税普通发票开始小规模纳税人或者开票资料不齐全时购买人，购买人取得后不可以进行进项税额抵扣，若您还有疑问，建议联系贵公司财务确认后在提交开票需求。
            </div>
          </Card>
          <Button className='subBtn' type='primary' onClick={this.subInfo}>
            提交
          </Button>
        </div>
      </div>
    );
  }
}
export default Personal;
